<template>
  <div class="box" :class="styleDf">
    <span :class="flag == 'today' && 'selected'" @click="changeflag('today')" class="days">今天</span>
    <span :class="flag == 'yesterday' && 'selected'" @click="changeflag('yesterday')" class="days">昨天</span>
    <span :class="flag == 'twoyesterday' && 'selected'" @click="changeflag('twoyesterday')" class="days">前天</span>
    <span class="text">选择日期</span>
    <template>
      <el-date-picker v-model="timevalue" type="date" placeholder="选择日期" :picker-options="pickerOptions"
        @change=changeflag>
      </el-date-picker>
    </template>
  </div>
</template>

<script>
import * as Time from "~/assets/libs/timeOptions";

export default {
  props: {
    styleDf: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      flag: "today",
      timevalue: new Date(),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      }
    };
  },
  methods: {
    changeflag(str) {
      this.flag = str;
      this.$emit("changepageindex");
      if (str == "today") {
        this.timevalue = new Date();
        this.commitdate(this.timevalue);
      } else if (str == "yesterday") {
        this.timevalue = Time.dateYestoday()
        this.commitdate(this.timevalue);
      } else if (str == "twoyesterday") {
        this.timevalue = Time.dateTwoYestoday()
        this.commitdate(this.timevalue);
      } else {
        this.commitdate(str)
      }
    },
    commitdate(t) {
      let str = Time.Format(t, "yyyy-MM-dd");
      this.$store.commit("lottery/setOwnDate", str);
      this.$store.commit("lottery/setPage", 1);
      this.$store.commit(
          "lottery/setHisLotteryList", []
        );
      this.$store.dispatch("lottery/queryHisPeriodsPage");
    }
  },
  mounted() {
    this.commitdate(new Date());
  }
};
</script>

<style lang="less" scoped>
.box {
  padding: 10px 20px;
  line-height: 32px;

  .days {
    display: inline-block;
    width: 44px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 4px;
    color: #555;
    font-size: 12px;
    margin: 0 2px;
    cursor: pointer;

    &:hover {
      color: #f44a07;
    }
  }

  .selected {
    background: #fa8e19;
    color: #fff;

    &:hover {
      color: #fff;
    }
  }

  .text {
    padding-left: 28px;
    padding-right: 10px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    font-weight: 300;
  }
}

.df {
  margin-left: 20px;
    display: flex;
    color: #333;
  .days {
    background-color: #fff;
    border: 1px solid #d3d3d3;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 30px;
    margin-right: 10px;
    cursor: pointer
  }
  .text {
    padding-left: 28px;
    padding-right: 10px;
    height: 28px;
    line-height: 34px;
    font-size: 14px;
    font-weight: 500;
  }
  .selected {
    background-color: #19aecf;
    border: 1px solid #19aecf;
    color: #fff
  }
}
</style>